import {useQuery, keepPreviousData, type UseQueryOptions, type UseQueryResult} from '@github-ui/react-query'
import {reactFetchJSON} from '@github-ui/verified-fetch'

// Intended to match the shape of the response from endpoints like
// `/orgs/{org}/security/alerts/code-scanning/repository-list.json`
export type AlertRepositoriesResponse = AlertRepository[]

export interface AlertRepository {
  // This is just the repo name, and not a NWO.
  value: string
}

export interface AlertRepositoriesQueryRequest {
  path: string
  query?: string
}

export function useAlertRepositoriesQuery(
  request: AlertRepositoriesQueryRequest,
  options?: Omit<
    UseQueryOptions<AlertRepositoriesQueryRequest, Error, AlertRepositoriesResponse>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<AlertRepositoriesResponse> {
  return useQuery({
    queryKey: ['item-picker-alert-repositories', request],
    queryFn: async () => {
      const {path, query = ''} = request
      const url = new URL(path, window.location.origin)
      if (query) url.searchParams.set('q', query)

      const response = await reactFetchJSON(url.href)
      if (!response.ok) {
        throw new Error(`${response.status} on ${response.url}`)
      }
      return response.json()
    },
    placeholderData: keepPreviousData,
    ...options,
  })
}
